import { ApolloClient } from "@apollo/client";
import { useToast } from "@songtradr-one/components-frontend";
import { bulkDownloadAction } from "./notification-action-bulk-download/NotificationActionBulkDownload.Parts";
import { inviteBatchAction } from "./notification-action-invite-batch/NotificationActionInviteBatch.Parts";

// TEXT

// STYLES

// DATA

// TYPES
type AddToast = ReturnType<typeof useToast>["addToast"];

export type NotificationActionContext = {
  addToast: AddToast;
  client: ApolloClient<object>;
  /** Goes to an in-app route and closes the panel. */
  navigate: (to: string) => void;
  /** Flattened notification `data` entries (key → value). */
  data: Record<string, string>;
};

/** A client-side action run when a notification of a given key is clicked. */
export type NotificationAction = (
  context: NotificationActionContext,
) => Promise<void> | void;

// CONSTANTS

// FUNCTIONS

/** Maps a notification `key` to the action run when that notification is clicked. */
export const notificationActions: Record<string, NotificationAction> = {
  "orgUser.inviteBatch.error": inviteBatchAction,
  "orgUser.inviteBatch.completed": inviteBatchAction,
  "orgUser.bulkDownload.completed": bulkDownloadAction,
};

// ASSETS
